import BackgroundImage from '../images/illustrations/mountain-landscape-desk-1x.webp';
import BackgroundImage2x from '../images/illustrations/mountain-landscape-desk-2x.webp';
import BackgroundImage3x from '../images/illustrations/mountain-landscape-desk-3x.webp';

export const searchHeaderBackground = {
  images: {
    '1x': BackgroundImage,
    '2x': BackgroundImage2x,
    '3x': BackgroundImage3x,
  },
  alt: 'train bus carpooling intermodal landscape',
};
